( function ( $ ) {
	const mainNavbar = $('#main-navbar')
	const mainNavbarToggler = $('#main-navbar-toggler');
	const mainNavbarNav = $('#main-navbar-nav');

	const scrollToTop = $('.scroll-top');

	const dropdownLink = $(".menu-item-has-children > .link-wrapper");

	$( document ).ready(function() {
		if($( window ).width() < 992) {
			dropdownLink.find(".navbar-nav").css("display", "none");
		}

	});

	mainNavbarToggler.click( function ( e ) {
		if($( window ).width() < 992){
			$(this).toggleClass("active");
			mainNavbar.toggleClass('expanded');

			if(mainNavbar.hasClass('expanded')){
				mainNavbarNav.addClass('fade-in');
				mainNavbarNav.removeClass('fade-out');
			}else{
				mainNavbarNav.addClass('fade-out');
				mainNavbarNav.removeClass('fade-in');
			}
		}
	} );

	scrollToTop.click(function (){
		window.scrollTo(0, 0);
	});

	dropdownLink.each(function(index, element){
		$(element).find('> a').click(function(e){
			e.preventDefault();

			if($( window ).width() < 992){
				$(element).toggleClass('slideToggleOpen');
				$(element).next(".navbar-nav").slideToggle();
			}
		});
	});


} )( jQuery );
